import { render, staticRenderFns } from "./LogOff.vue?vue&type=template&id=4e98089a&scoped=true"
import script from "./LogOff.vue?vue&type=script&lang=js"
export * from "./LogOff.vue?vue&type=script&lang=js"
import style0 from "./LogOff.vue?vue&type=style&index=0&id=4e98089a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e98089a",
  null
  
)

export default component.exports